import { CommonModule } from "@angular/common";
import { Component, Input, OnInit, inject } from "@angular/core";
import { IonicModule, ModalController } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { map, takeWhile, timer } from "rxjs";

@Component({
  selector: "cas-alert",
  templateUrl: "./casino-alert.html",
  styleUrls: ["./casino-alert.scss"],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule],
})
export class casinoAlertModal implements OnInit {
  @Input() restTime: number = 0;
  translate = inject(TranslateService);
  timeToShow$;
  textslots;

  constructor(public modalCtrl: ModalController) {}

  ngOnInit(): void {
    this.textslots = this.translate.instant("accessSlotsRestTime").replace("<br>", "");
    // timer cuenta atrás para abrir una nueva sesión (autoexclusión del usuario)
    this.timeToShow$ = timer(0, 1000).pipe(
      map((n) => (this.restTime - n) * 1000),
      takeWhile((n) => n >= 0),
    );
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
